export default __webpack_public_path__ + "static/casey-ceremony-bd53fe7271dfb9708550e650cd0c6285.mp3";